import { WorkTypeTypes } from '../../../lib/constants';

export default function defaultWorkType(workTypes) {
  if (workTypes.size === 0) {
    return {};
  }

  const workWorkType = workTypes.find(workType => workType.type === WorkTypeTypes.work);
  if (workWorkType) {
    return workWorkType;
  }

  return workTypes.first();
}
